<template>
  <div class="main">
    <div class="footer">
      <div class="content">
        <div class="logo">
          <img src="../assets/logo2.png" />
        </div>
        <div class="links">
          <div>
            <h3>支持与服务</h3>
            <p @click="$router.push({ path: '/' })">
              <a>产品服务</a>
            </p>
            <p @click="$router.push({ path: '/solution?index=1' })">
              <a>解决方案</a>
            </p>
            <p @click="$router.push({ path: '/kowus' })">
              <a>了解我们</a>
            </p>
          </div>
          <div>
            <h3>联系我们</h3>
            <p>
              <img src="../assets/icon-company.png" />
              <span>北京联运管家供应链管理有限公司</span>
            </p>
            <p>
              <img src="../assets/icon-emil.png" />
              <span>service@56links.com</span>
            </p>
            <p>
              <img src="../assets/icon-address.png" />
              <span>黑龙江省哈尔滨市南岗区铁路街8号23、24层<br />北京海淀区农大南路1号院2号楼7层办公B-703</span>
            </p>
          </div>
          <div class="qrcode">
            <h3>关注我们</h3>
            <div>
              <img src="../assets/qrcode-gzh.png" />
              <img src="../assets/qrcode-xcx.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">Copyright © 2019-{{ new Date().getFullYear() }} 北京联运管家供应链管理有限公司 版权所有ICP备案号:京ICP备20002183号-1</div>
  </div>
</template>

<script>
export default {
  name: "footerBar",
}
</script>

<style scoped>
@media screen and (min-width: 1025px) {
  .footer {
    height: 4.96rem;
    background: #0b1d30;
    padding-top: 1.2rem;
  }

  .footer .content {
    width: 14rem;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
  }

  .footer .content .logo {
    width: 2rem;
    height: 1.5rem;
    margin-top: 0.6rem;
    border-right: 1px solid rgba(255, 255, 255, 0.18);
  }

  .footer .content .logo img {
    width: 1.6rem;
    display: block;
  }

  .footer .content .links {
    flex: 1;
    margin: 0 0.2rem 0 0.7rem;
    display: flex;
    align-items: flex-start;
  }

  .footer .content .links div {
    width: 30%;
  }

  .footer .content .links div + div {
    width: 70%;
  }

  .footer .content .links div h3 {
    font-size: 0.2rem;
    color: #fff;
    font-weight: bold;
  }

  .footer .content .links div img {
    margin-right: 0.2rem;
    width: 0.17rem;
  }

  .footer .content .links div p {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 0.36rem;
  }

  .footer .content .links div p a {
    font-size: 0.16rem;
    cursor: pointer;
  }

  .footer .content .links div p span {
    font-size: 0.16rem;
  }

  .footer .content .qrcode {
    margin-left: auto;
  }

  .footer .content .qrcode h3 {
    font-size: 0.2rem;
    color: #fff;
    font-weight: bold;
  }

  .footer .content .qrcode div {
    margin-top: 0.3rem;
    display: flex;
    align-items: center;
  }

  .footer .content .qrcode div img {
    width: 1.58rem;
  }

  .footer .content .qrcode div img + img {
    margin-left: 0.2rem;
  }

  .copyright {
    text-align: center;
    line-height: 0.8rem;
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.14rem;
    background: #071625;
  }
}

@media screen and (max-width: 1024px) {
  .footer {
    background: #0b1d30;
    padding: 0.2rem 0.3rem;
  }

  .footer .content .logo {
    display: none;
  }

  .footer .content .links {
    background: url("../assets/logo4.png") no-repeat right top;
    background-size: 1.2rem;
  }

  .footer .content .links div:first-child {
    display: none;
  }

  .footer .content .links div h3 {
    color: #fff;
    font-size: 0.28rem;
    font-weight: bold;
    margin-bottom: 0.1rem;
  }

  .footer .content .links div p {
    display: flex;
    align-items: flex-start;
  }

  .footer .content .links div p img {
    width: 0.26rem;
    margin-top: 0.06rem;
  }

  .footer .content .links div p span {
    line-height: 0.38rem;
    font-size: 0.24rem;
    color: #9c9999;
    font-family: SongTi;
    margin-left: 0.2rem;
  }

  .footer .content .qrcode div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.4rem;
  }

  .footer .content .qrcode div img {
    width: 1.64rem;
  }

  .copyright {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerBar.vue